import { Navigate } from 'react-router-dom'
import { ROUTES } from './routes.js'
import { useAuthStore } from '../shared/store/auth.store.js'
import LoadingPage from '../pages/loading/LoadingPage.js'
import LandingPage from '../pages/landing/LandingPage.js'

export default function RootRoute() {
  const status = useAuthStore(s => s.status)

  if (status === 'initializing') return <LoadingPage />
  if (status === 'authenticated') return <Navigate to={ROUTES.ORDERS} replace />

  return <LandingPage />
}
